import { GridColDef } from '@mui/x-data-grid-premium';
import { DataGridLinkCell } from 'components/cells';
import { createColumns } from 'components/enhanced/data-grid/utils';
import { IRequestDepartmentTranscode } from 'features/settings/transcodes/request-department-transcodes/types';
import { useTranslation } from 'react-i18next';

export function RequestLaboratoryTranscodeColumns(): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<IRequestDepartmentTranscode>(
    [
      {
        field: 'department',
        renderCell: (params) => (
          <DataGridLinkCell
            params={params}
            basePath="/tenant/department-transcodes"
            idKey="id"
            passDuplicateState
          />
        )
      },
      {
        field: 'laboratory'
      }
    ],
    t
  );
}
